import { TypePolicies } from '@apollo/client';

const CAPARfqReviewCache: TypePolicies = {
  CAPARfqReview: {
    merge(existing, incoming, { mergeObjects }) {
      return mergeObjects(existing, incoming);
    }
  }
};

export default CAPARfqReviewCache;
